




import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import OptionDropDownSelector from "../system/selectors/OptionDropDownSelector.vue";
import { ModelEditableMixin, DisableableMixin } from "../system/mixins";
import { StandardOption } from "../system/selectors/mixins";

@Component({
  components: {
    selector: OptionDropDownSelector,
  },
})
export default class ScaleDropDownSelector extends Mixins(ModelEditableMixin, DisableableMixin) {
  @Prop({ default: true })
  isEnable: boolean;

  get scaleOptions(): StandardOption<number>[] {
    const optionValues = [
      50,
      75,
      80,
      85,
      90,
      95,
      100,
      125,
      150,
      175,
      200,
    ];
    if (this.$configuration.behavior.document.editor.documentAttributes.scale.defaultScaleAsPercentage) {
      optionValues.push(this.$configuration.behavior.document.editor.documentAttributes.scale.defaultScaleAsPercentage);
    }
    return Enumerable.from(optionValues)
      .distinct()
      .orderBy(v => v)
      .select(i => new StandardOption<number>(i + "%", i / 100))
      .toArray();
  }
}
